import styled, { css } from 'styled-components';
import { shade } from 'polished';
import { DefaultColors } from '../../styles/global'

import CountDown from '../PageCountdown';

interface HeaderProps {
  tab?: string;
}

export const Container = styled.header`
  z-index: 50;
  width: 59%;
  height: 55px;

  box-sizing: border-box;
  /* margin-bottom: 35px; */

  display: flex;
  align-items: flex-start;

  @media (max-width: 820px) {
    width: 100%;
  }
`;

export const StyledCountDown = styled(CountDown)``;

export const LogoContent = styled.div`
  width: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
`;

export const MainImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const LogoOptions = styled.div`
  background: ${DefaultColors.primaryColor};
  transform: skew(20deg);
  justify-content: flex-end;
  align-items: center;

  width: 569px;
  height: 55px;
  min-height: 55px;

  margin-left: -10px;
  display: flex;
  flex-direction: row;

  @media (max-width: 820px) {
    width: 100%;
    max-width: 100%;
  }

  a {
    text-decoration: none;
  }

  p {
    margin-right: 48px;
    color: #fff;

    transition: color 0.4s;

    font-family: 'Poppins';
    font-size: 12px;

    @media (max-width: 820px) {
      margin-right: 15px;
    }

    &:hover {
      cursor: pointer;
      color: ${shade(0.4, '#bdbdbd')};
    }
  }
`;

export const HomeOption = styled.p<HeaderProps>`
  display: flex;
  align-items: center;

  svg {
    font-size: 16px;
    margin: 0 5px 0 0;
  }

  ${(props) =>
    props.tab === 'home' &&
    css`
      /* border-bottom: 1px solid #fff; */
    `}
`;

export const RegulationOption = styled.p<HeaderProps>`
  transform: skew(-20deg);
  display: flex;
  align-items: center;

  svg {
    font-size: 16px;
    margin: 0 5px 0 0;
  }

  ${(props) =>
    props.tab === 'regulamento' &&
    css`
      border-bottom: 1px solid #fff;
    `}
`;

export const Logo = styled.img`
  height: 65px;
  margin-left: 30px;
  margin-top: 5px;
  opacity: 1;
  cursor: pointer;

  @media (max-width: 820px) {
    display: none;
  }
`;

export const UserContainer = styled.div`
  transform: skew(-20deg);

  width: 450px;
  height: 64px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 820px) {
    width: 100%;
    max-width: 100%;
  }

  .user-data-container {
    color: #e9eaed;
    width: 80%;
    cursor: pointer;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: 820px) {
      margin-right: 10px;
    }

    h3 {
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    p {
      font-size: 14px;
    }
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;

  flex-shrink: 0;
  margin-right: 10px;

  .main-profile-img {
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transition: 0.4s;
    border: solid 2px #dbdbdb;
  }
`;
